import { OrderStatus7Days } from "../../../../models/Order";
import type { ExportOption } from "../types/orderExportTypes";

export const exportStatuses: ExportOption[] = [
  OrderStatus7Days.Unpaid, OrderStatus7Days.NewOrder, OrderStatus7Days.ReadyToShip,
  OrderStatus7Days.Shipping, OrderStatus7Days.Completed, OrderStatus7Days.Cancelled,
  OrderStatus7Days.Return, "PROCESSED",
].map((value) => ({ value, label: value }));

export const exportFileTypes = [
  { value: "headerLess", label: "HeaderLess" },
  { value: "header", label: "Header" },
];
